import { toWords } from "number-to-words";

export const getPreviousYearRange = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    const startDate = new Date(date);
    startDate.setFullYear(date.getFullYear() - 1);
    return {
        previousStartDate: formatLocalDate(startDate),
        previousEndDate: formatLocalDate(date)
    };
}

export const getCurrentYearRange = () => {
    const date = new Date();
    const startDate = new Date(date);
    startDate.setFullYear(date.getFullYear() + 1);
    return {
        currentStartDate: formatLocalDate(date),
        currentEndDate: formatLocalDate(startDate)
    };
}

export const getNextYearRange = () => {
    const sdate = new Date();
    sdate.setDate(sdate.getDate() + 1);
    const startDate = new Date(sdate);
    const edate = new Date();
    const endDate = new Date(edate);
    startDate.setFullYear(sdate.getFullYear() + 1);
    endDate.setFullYear(edate.getFullYear() + 2);
    return {
        nextStartDate: formatLocalDate(startDate),
        nextEndDate: formatLocalDate(endDate)
    };
}
const formatLocalDate = (date) => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}
export const formatFilterDate = (date) => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}
export const formatDateYMD = (_date) => {
    const date = new Date(_date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
export const customFormatDate = (_date) => {
    const date = new Date(_date);

    const options = {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };

    const formattedDate = date.toLocaleString('en-US', options)
        .replace(',', '')
        .replace('at', '');

    return formattedDate;
}
export const formatDate = (_date) => {
    const date = new Date(_date)
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
}
export const formatMonth = (_date) => {
    const date = new Date(_date)
    return `${date.toLocaleString('en-EN', { month: "short" })} ${date.getDate()}`
}
export const formatDateTime = (_date) => {
    const date = new Date(_date)
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`
}
export const formatTime = (_date) => {
    const date = new Date(_date)
    return `${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`
}
export const formatDayDateTime = (dateInput) => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const dayName = days[date.getDay()];
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${dayName} ${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
}
export const extractNumber = (value) => {
    const numbersOnly = value.replace(/\D/g, '');
    const numbersAsNumber = parseInt(numbersOnly, 10);
    return numbersAsNumber
}
export const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

export const convertToIndianWords = (amount) => {
    if (isNaN(amount)) return "Invalid number";

    // Ensure proper formatting
    const formattedAmount = parseFloat(amount).toFixed(2);
    const [integerPart, decimalPart] = formattedAmount.split(".");

    // Convert integer part using Indian Numbering System
    const num = parseInt(integerPart, 10);
    let words = convertIndianNumberToWords(num) + " rupees";

    // Convert decimal part (paise)
    if (decimalPart && parseInt(decimalPart) > 0) {
        words += " and " + toWords(parseInt(decimalPart)) + " paise";
    }

    return words.charAt(0).toUpperCase() + words.slice(1); // Capitalize first letter
}

export const convertIndianNumberToWords = (num) => {
    const units = [
        "", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
        "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
        "seventeen", "eighteen", "nineteen",
    ];

    const tens = [
        "", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety",
    ];

    if (num === 0) return "zero";

    let word = "";

    if (num >= 10000000) {
        word += convertIndianNumberToWords(Math.floor(num / 10000000)) + " crore ";
        num %= 10000000;
    }

    if (num >= 100000) {
        word += convertIndianNumberToWords(Math.floor(num / 100000)) + " lakh ";
        num %= 100000;
    }

    if (num >= 1000) {
        word += convertIndianNumberToWords(Math.floor(num / 1000)) + " thousand ";
        num %= 1000;
    }

    if (num >= 100) {
        word += convertIndianNumberToWords(Math.floor(num / 100)) + " hundred ";
        num %= 100;
    }

    if (num > 0) {
        if (word !== "") word += "and ";
        if (num < 20) word += units[num];
        else {
            word += tens[Math.floor(num / 10)];
            if (num % 10 > 0) word += "-" + units[num % 10];
        }
    }

    return word.trim();
}

export const addDays = (days) => {
    let today = new Date();
    today.setDate(today.getDate() + days);
    let day = String(today.getDate()).padStart(2, "0");
    let month = String(today.getMonth() + 1).padStart(2, "0");
    let year = today.getFullYear();
    return `${year}-${month}-${day}`
}

export const getToday = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export const getLastDayOfMonth = (_year, _month) => {
    const date = new Date(_year, _month + 1, 0);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const getDisplayYear = (month) => {
    const currentYear = new Date().getFullYear();
    if (month === "january") {
        return `${currentYear}`;
    } else if (month === "april") {
        return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    } else {
        return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    }
};

export const getYearFormat = () => {
    const presentYear = new Date().getFullYear();
    const previousAndCurrentYear = [presentYear - 1, presentYear];
    const currentAndNextYear = [`${presentYear - 1}-${(presentYear).toString().slice(-2)}`, `${presentYear}-${(presentYear + 1).toString().slice(-2)}`];
    return { previousAndCurrentYear, currentAndNextYear }
}

const monthShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const monthFull = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

export const dynamicDateFormat = (format) => {
    const date = new Date();
    const dd = String(date.getDate()).padStart(2, '0');
    const d = String(date.getDate());
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const m = String(date.getMonth() + 1);
    const yyyy = date.getFullYear();
    const yy = String(yyyy).slice(-2);
    const MMM = monthShort[date.getMonth()];
    const MMMM = monthFull[date.getMonth()];

    return format
        .replace(/DD/g, dd)
        .replace(/D/g, d)
        .replace(/MMMM/g, MMMM)
        .replace(/MMM/g, MMM)
        .replace(/MM/g, mm)
        .replace(/M/g, m)
        .replace(/YYYY/g, yyyy)
        .replace(/YY/g, yy);
};

export const formatLabel = (str) => {
    return str
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize
        .join(" ");
};

export const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
        return "Just now";
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
        return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
        return `${diffInMonths} month${diffInMonths > 1 ? "s" : ""} ago`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} year${diffInYears > 1 ? "s" : ""} ago`;
};

export const formatSimpleDate = (dateStr) => {
    if (dateStr) {
        const [year, month, day] = dateStr.split("-");
        return `${day}/${month}/${year}`;
    } else { return '' }
};